/** Domain routing only; authorization stays in Firebase and AdminGate. */
export const ADMIN_HOST = 'admin.dala.delivery';
export const MARKETING_ORIGIN = 'https://dala.delivery';
export const isAdminHost = window.location.hostname === ADMIN_HOST;

/** Keep local/default Firebase URLs compatible with the original /admin routes. */
export function adminPath(path = '/admin'): string {
  if (!isAdminHost) return path;
  return path.replace(/^\/admin(?=\/|\?|#|$)/, '') || '/';
}

export const marketingHome = isAdminHost ? MARKETING_ORIGIN : '/';
